import React, { useState } from 'react';
import { Button, TextField, Container, Typography, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { tokenManager } from '../api/apiutils';  

const SendCodeForm = () => {
  const [userName, setUserName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!userName) {
      setErrorMessage('Пожалуйста, введите имя пользователя');
      return;
    }


    localStorage.setItem('saved_userName', userName);

    const formData = new URLSearchParams();
    formData.append('userName', userName);

    try {
      const response = await fetch('/api/users/sendcode', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (!response.ok) {
        const errorText = await response.text();
        setErrorMessage(`Ошибка отправки кода: ${errorText}`);
        return;
      }

      const responseData = await response.json();
      const code = responseData.code;

      if (code) {
        localStorage.setItem('saved_code', code);

        const loginFormData = new URLSearchParams();
        loginFormData.append('userName', userName);
        loginFormData.append('code', code);

        try {
          const loginResponse = await fetch('/api/users/login', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: loginFormData.toString(),
          });

          if (!loginResponse.ok) {
            const errorText = await loginResponse.text();
            throw new Error(`Ошибка входа: ${loginResponse.status}, Details: ${errorText}`);
          }

          const loginData = await loginResponse.json();
          tokenManager.setTokens(loginData.token, loginData.refreshToken);

          navigate('/active-users');
        } catch (error) {
          setErrorMessage('Ошибка при попытке войти в систему. Пожалуйста, попробуйте снова.');
        }
      } else {
        navigate('/login');
      }
    } catch (error) {
      setErrorMessage('Ошибка при попытке отправить код. Пожалуйста, попробуйте снова.');
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: { xs: 6, sm: 12 } }}>
      <Typography variant="h5" gutterBottom>
        Отправить код
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Имя пользователя"
          variant="outlined"
          fullWidth
          margin="normal"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          required
        />
        {errorMessage && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {errorMessage}
          </Alert>
        )}
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
        >
          Отправить код
        </Button>
      </form>
    </Container>
  );
};

export default SendCodeForm;
